module.exports = __webpack_public_path__ + "img/asset7.b7e90db0.png";